import { render, staticRenderFns } from "./ReservierungVorbestellung.vue?vue&type=template&id=a375b2e2"
import script from "./ReservierungVorbestellung.vue?vue&type=script&lang=ts"
export * from "./ReservierungVorbestellung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports